import React from 'react'
import {Link} from 'react-static'

import Navigation from '../components/Navigation'
import AccountMenu from '../components/AccountMenu'

export default ({authUser, account, children}) =>
  <div id="wrapper">
    {/* Top Bar Start */}
    <div className="topbar">
        {/* LOGO */}
        <div className="topbar-left">
            <div className="text-center">
                <Link to='/' className="logo">
                  <img src="/logo_light_32.png" alt="logo"/>
                  <span>ColorRibbon</span>
                </Link>
            </div>
        </div>

        <nav className="navbar-custom">
          <AccountMenu authUser={authUser} position='right' account={account}/>
        </nav>
    </div>
    {/* Top Bar End */}

    {/* ========== Left Sidebar start ========== */}
    <div className="left side-menu">
        <div className="sidebar-inner slimscrollleft">
            {/*- Divider */}
            <div id="sidebar-menu">
              <Navigation authUser={authUser}/>
            </div>
        </div>
    </div>
    {/* ========== Left Sidebar end ========== */}

    {/* ========== main content start ========== */}
    <div className="content-page">

        {/* content */}
        <div className="content">
          <div className="container-fluid">
            {children}
          </div>  
        </div>

        {/* footer */}
        <footer className="footer">
            {(new Date()).getFullYear()} © ColorRibbon.
        </footer>
    </div>

    {/* ========== main content end ========== */}


    {/* ========== Right sidebar start ========== */}
    <div className="side-bar right-bar nicescroll">

    </div>

    {/* ========== Right sidebar end ========== */}
  </div>



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/DashboardLayout.js